import { createSlice } from "@reduxjs/toolkit";

import { PAGES } from "../../constants/pages";

const initialState = {
  // All
  pageToShowIndex: 0, // PAGES = { 0: "SIMULATION", 1: "POSTCODE ALLOCATION" }
  pageLoading: false,
  signInErrorMessage: "",
  showErrorModal: false,
  errorModalMessage: "",
  // Simulation
  volumeOverlayDate: null,
  simulationPercentage: 0,
  simulatedVolumeOverlayData: null,
  overlayTimeBand: null,
  defaultOverlayData: [],
  activeDatesForSimulationDatePicker: [],
  // Postcode Allocation
  allDepotList: [],
  depotsVisibleOnMapList: [],
  depotColourMap: [],
  fullMapParcelList: [],
  fullMapOverlayDate: null,
  activeDatesForAllocationDatePicker: [],
};

export const appSlice = createSlice({
  name: "vs_app",
  initialState,
  reducers: {
    setPageToShowIndex: (state, action) => {
      if (Object.keys(PAGES).map(Number).includes(action.payload)) {
        state.pageToShowIndex = action.payload;
      } else {
        state.pageToShowIndex = 0;
      }
    },
    setPageLoading: (state, action) => {
      state.pageLoading = action.payload;
    },
    setSignInErrorMessage: (state, action) => {
      state.signInErrorMessage = action.payload;
    },
    setShowErrorModal: (state, action) => {
      state.showErrorModal = action.payload;
    },
    setErrorModalMessage: (state, action) => {
      state.errorModalMessage = action.payload;
    },
    setVolumeOverlayDate: (state, action) => {
      state.volumeOverlayDate = action.payload;
    },
    setSimulationPercentage: (state, action) => {
      state.simulationPercentage = action.payload;
    },
    setSimulatedVolumeOverlayData: (state, action) => {
      state.simulatedVolumeOverlayData = action.payload;
    },
    setDefaultOverlayData: (state, action) => {
      state.defaultOverlayData = action.payload;
    },
    setOverlayTimeBand: (state, action) => {
      state.overlayTimeBand = action.payload;
    },
    setActiveDatesForSimulationDatePicker: (state, action) => {
      state.activeDatesForSimulationDatePicker = action.payload;
    },
    setAllDepotList: (state, action) => {
      state.allDepotList = action.payload;
      state.depotsVisibleOnMapList = action.payload;
    },
    setDepotsVisibleOnMapList: (state, action) => {
      state.depotsVisibleOnMapList = action.payload;
    },
    setDepotColourMap: (state, action) => {
      state.depotColourMap = action.payload;
    },
    setFullMapParcelList: (state, action) => {
      state.fullMapParcelList = action.payload;
    },
    setFullMapOverlayDate: (state, action) => {
      state.fullMapOverlayDate = action.payload;
    },
    setActiveDatesForAllocationDatePicker: (state, action) => {
      state.activeDatesForAllocationDatePicker = action.payload;
    },
    resetPageData: (state, action) => {
      state.volumeOverlayDate = null;
      state.simulationPercentage = 0;
      state.defaultOverlayData = [];
      state.overlayTimeBand = null;
      state.simulatedVolumeOverlayData = null;
    },
    resetAppState: (state, action) => {
      state = initialState;
    },
  },
});

const { reducer, actions } = appSlice;
const {
  setPageToShowIndex,
  setVolumeOverlayDate,
  setSimulationPercentage,
  setSimulatedVolumeOverlayData,
  setOverlayTimeBand,
  setAllDepotList,
  setDepotsVisibleOnMapList,
  setDepotColourMap,
  setActiveDatesForAllocationDatePicker,
  setActiveDatesForSimulationDatePicker,
  setPageLoading,
  setDefaultOverlayData,
  setSignInErrorMessage,
  setErrorModalMessage,
  setShowErrorModal,
  setFullMapParcelList,
  setFullMapOverlayDate,
  resetPageData,
  resetAppState,
} = actions;
export {
  initialState,
  reducer,
  setPageToShowIndex,
  setVolumeOverlayDate,
  setSimulationPercentage,
  setSimulatedVolumeOverlayData,
  setOverlayTimeBand,
  setAllDepotList,
  setDepotsVisibleOnMapList,
  setDepotColourMap,
  setActiveDatesForAllocationDatePicker,
  setActiveDatesForSimulationDatePicker,
  setPageLoading,
  setDefaultOverlayData,
  setSignInErrorMessage,
  setErrorModalMessage,
  setShowErrorModal,
  setFullMapParcelList,
  setFullMapOverlayDate,
  resetPageData,
  resetAppState,
};
